module.exports = __webpack_public_path__ + "img/index-8.1f97332b.png";